import api, {FrontLights, SideLights} from '@/api/panel-api';
import {Logger} from '@vanti/vue-logger';
import {PanelLights} from './panel-lights';

const log = Logger.get('qbic-panel-lights');

/**
 * QBIC Panel integration
 */
export class PanelLightsQbic extends PanelLights {
  /**
   * @param {VuexStore} store
   */
  constructor(store) {
    super(store);
    this.isLocal = location.hostname === 'localhost';
  }

  /**
   * Set LEDs on room state change
   * @param {RoomState} state
   */
  async onRoomStateChange(state) {
    const color = this.colorForState(state);
    if (!color) {
      log.error(`invalid color for room state: ${state}`);
      return;
    }
    if (this.isLocal) {
      log.debug(`skipping setting color to`, color);
      return;
    }

    log.debug(`setting color to`, color);
    try {
      await api.led.post(`/${SideLights}`, color);
      await api.led.post(`/${FrontLights}`, color);
    } catch (e) {
      log.error(e);
    }
  }

  /**
   * check the LED status is correct
   */
  runLedCheck() {
    const state = this._roomState;
    const color = this.colorForState(state);
    if (!color) {
      log.error(`invalid color for room state: ${state}`);
      return;
    }

    this.checkAndSetLed(SideLights, color);
    this.checkAndSetLed(FrontLights, color);
  }

  /**
   * Check LED state, and set to color if not set to color already
   * @param {String} name
   * @param {{red: number, green: number, blue: number}} color
   */
  async checkAndSetLed(name, color) {
    try {
      const rgb = await api.led.getJson(`/${name}`);
      if (rgb.red !== color.red || rgb.green !== color.green || rgb.blue !== color.blue) {
        await api.led.post(`/${name}`, color);
      }
    } catch (e) {
      log.error(e);
    }
  }

  /**
   * @param {RoomState} state
   * @return {RGB}
   */
  colorForState(state) {
    const color = Colors[state];
    const brightness = this._brightness;
    if (brightness === 1) {
      return color;
    }
    return {
      red: Math.round(color.red * brightness),
      green: Math.round(color.green * brightness),
      blue: Math.round(color.blue * brightness)
    };
  }
}

/**
 * @typedef {Object} RGB
 * @property {number} red
 * @property {number} green
 * @property {number} blue
 */

/**
 * @type {Object<RoomState, RGB>}
 */
const Colors = {
  AVAILABLE: {red: 0, green: 255, blue: 0},
  OCCUPIED: {red: 255, green: 0, blue: 0},
  BOOKED: {red: 255, green: 140, blue: 0},
  MAINTENANCE: {red: 128, green: 0, blue: 128},
  red: {red: 255, green: 0, blue: 0},
  green: {red: 0, green: 255, blue: 0},
  off: {red: 0, green: 0, blue: 0}
};
